import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    forwardRef,
    HostBinding,
    HostListener,
    Inject,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import { Subject } from 'rxjs';
import { PopoverContainerDirective } from './popover-container.directive';
import { UntypedFormArray } from '@angular/forms';

@Directive({
    selector: '[appPopoverOption]'
})
export class PopoverOptionDirective implements OnInit, OnDestroy {
    unsubscribe$ = new Subject();

    @Input() appPopoverOption: any;
    @Input() index: number | undefined;
    @HostBinding('attr.role') role = 'option';
    @HostBinding('attr.aria-selected') selected: null | boolean = null;
    @HostBinding('attr.id') id = '';
    @HostListener('click', ['$event']) clickHandler(event: PointerEvent) {
        this.select(event);
    }

    select = (event: Event) => {
        const newValue = this.appPopoverOption;

        // if multiselect
        if (this.popover.popover.config.multiselect) {
            const currentSelection: Array<any> = this.popover.control.value;
            const currentIndex = currentSelection?.findIndex(
                (item) => item.value === newValue.value
            );
            const formControl = (this.popover.control as UntypedFormArray).controls[
                currentIndex
            ];
            if (formControl) {
                this.selected = !formControl.value?.selected;
                formControl.setValue({ ...formControl.value, selected: this.selected });
            }
        } else {
            const formControl = this.popover.control;
            if (formControl) {
                this.selected = !formControl.value?.selected;
                formControl.setValue({ ...formControl.value, selected: this.selected });
            }
        }
    };
    constructor(
        @Inject(forwardRef(() => PopoverContainerDirective))
        public popover: PopoverContainerDirective,
        private cdr: ChangeDetectorRef,
        public elRef: ElementRef
    ) {}

    ngOnInit() {
        this.selected = this.appPopoverOption.selected;
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
